import { takeLatest, put, call } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify";
import {
  addKarat,
  addPurity,
  changeStatus,
  updateSellOutTime,
  addMetal,
  addQuantity,
  removeQuantity,
  downloadMetalReport,
  // addBullionRates,
  addBullion,
  setMessage,
  setError,
  fetchKarat,
  setKaratList,
  getMetals,
  setMetals,
  setPurityList,
  getPuritiesByKaratId,
  setEnabledMetal,
  getMetalHistory,
  setMetalHisory,
  updateRedeemTimeOut,
} from "../slices/manageMetals";

function* handleMetalName(action) {
  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion/addBullion`,
      action.payload,
    );

    if (!res?.data?.success) {
      toast.error(res.data.message);
      yield put(setError(res.data.message || "Something went wrong!"));
      return;
    }

    toast.success(res.data.message);
    yield put(getMetals({}));
    yield put(setMessage("Metal added successfully"));
  } catch (err) {
    yield put(
      setError(err.response?.data?.message || "Failed to add metalName"),
    );
  }
}

function* handleAddPurity(action) {
  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/savepurity`,
      action.payload,
    );

    if (res.data.success) {
      toast.success(res.data.message);
      yield put(setMessage(res.data.message, res));
      return;
    }

    toast.error(res.data.message);
    yield put(setError(res.data.message || "Something wrong!"));
    return;
  } catch (err) {
    yield put(setError(err.response?.data?.message || "Failed to add purity"));
  }
}

function* handleFetchKarat(action) {
  try {
    const res = yield axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/fetchKarat`,
      action.payload,
    );

    if (res?.data.success) {
      yield put(setKaratList(res?.data?.data || []));
    }

    yield put(setError(res.data.message || "Something wrong!"));
    return;
  } catch (err) {
    yield put(setError(err.response?.data?.message || "Failed to add purity"));
  }
}

function* handleAddKarat(action) {
  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/savekarat`,
      action.payload,
    );

    if (!res?.data?.success) {
      toast.error(res.data.message);
      yield put(setError(res.data.message || "Something wrong!"));
      return;
    }
    toast.success(res.data.message);
    yield put(setMessage(res?.data?.message || "Something wrong!"));
  } catch (err) {
    yield put(setError(err.response?.data?.message || "Failed to add karat"));
  }
}

function* handleChangeStatus(action) {
  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion/changeMetalStatus`,
      action.payload,
    );

    if (res.data.success) {
      toast.success(res.data.message);
      yield put(getMetals({}));
      yield put(setMessage("Metal Status Changed successfully"));
      return;
    }

    toast.error(res.data.message);
    yield put(setError(res.data.message || "Something wrong!"));
  } catch (err) {
    yield put(
      setError(err.response?.data?.message || "Failed to change status"),
    );
  }
}

// function* handleaddBullion(action) {
//   try {
//     const res = yield axios.post(
//       `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion/changeMetalStatus`,
//       action.payload
//     );
//     yield put(setMessage("Metal Status Changed successfully"));
//     console.log("res", res.data.errormsg);
//     if (res?.data?.errormsg) {
//       yield put(setError(res.data.errormsg || "Something wrong!"));
//       return;
//     }
//   } catch (err) {
//     yield put(
//       setError(err.response?.data?.message || "Failed to change status")
//     );
//   }
// }
function* handleUpdateSellOutTime(action) {
  try {
    const res = yield axios.post(
      ` ${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion/updateSellOutTime`,
      action.payload,
    );
    if (!res?.data?.success) {
      toast.error(res.data.message);
      yield put(setError(res.data.message || "Something wrong!"));
      return;
    }
    toast.success(res.data.message);
    yield put(getMetals());
    yield put(setMessage(res.data.message));
  } catch (err) {
    yield put(setError(err.response?.data?.message || "Failed to add time"));
  }
}

function* handleAddQuantity(action) {
  try {
    const res = yield axios.post(
      ` ${process.env.REACT_APP_API_BASE_URL}/api/v1/metal-balance/addMetalBalance`,
      action.payload,
    );

    if (!res?.data?.success) {
      toast.error(res.data.message);
      yield put(setError(res.data.message || "Something wrong!"));
      return;
    }

    toast.success(res.data.message);
    yield put(getMetalHistory());
  } catch (err) {
    yield put(
      setError(err.response?.data?.message || "Failed to add quantity"),
    );
  }
}

function* handleRemoveQuantity(action) {
  try {
    const res = yield axios.post(
      ` ${process.env.REACT_APP_API_BASE_URL}/api/v1/metal-balance/removeMetalBalance`,
      action.payload,
    );

    if (!res.data.success) {
      toast.error(res.data.message);
      yield put(setError(res.data.message || "Something wrong!"));
      return;
    }

    toast.success(res.data.message);
    yield put(getMetalHistory());
    yield put(setMessage(res.data.message));
  } catch (err) {
    yield put(
      setError(err.response?.data?.message || "Failed to Remove quantity"),
    );
  }
}

function* handleDownloadMetalReport(action) {
  try {
    const res = yield axios.post(
      ` ${process.env.REACT_APP_API_BASE_URL}/api/v1/metal-balance/downloadMetalReport`,
      action.payload,
    );

    if (!res.data.success) {
      toast.error(res.data.message);
      return;
    }
    window.open(`${process.env.REACT_APP_API_BASE_URL}${res.data.data.data}`);
    return;
  } catch (err) {
    yield put(
      setError(err.response?.data?.message || "Failed to Remove quantity"),
    );
  }
}

function* handleGetMetals(action) {
  try {
    let payload = action.payload;
    console.log("action.==", payload);
    const res = yield axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/getMetals`,
    );
    // const metals = res?.data?.value || [];
    if (!res?.data?.success) {
      yield put(setError(res.data.errormsg || "Something wrong!"));
      return;
    }

    yield put(setMetals(res.data.data.metals));
    yield put(setEnabledMetal(res.data.data.metalsenabled));
  } catch (err) {
    yield put(setError(err.response?.data?.message || "Failed to get metal"));
  }
}
function* handleaddBullion(action) {
  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion/addBullion`,
      action.payload,
    );
    if (res?.data?.errormsg) {
      yield put(setError(res.data.errormsg || "Something wrong!"));
      return;
    }

    yield put(setMetals(res.data));
  } catch (err) {
    yield put(setError(err.response?.data?.message || "Failed to get metal"));
  }
}

function* getPurities(action) {
  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/getPuritiesByKaratId`,
      action.payload,
    );

    if (!res?.data?.success) {
      yield put(setError(res.data.errormsg || "Something wrong!"));
      return;
    }

    // ✅ Add `id` to each item using map
    yield put(setPurityList(res.data.data));
  } catch (err) {
    yield put(setError(err.response?.data?.message || "Failed to get metal"));
  }
}

function* handleGetMetalHistory(action) {
  const { page = 1, limit = 10, search = "" } = action.payload || {};
  try {
    const res = yield axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/metal-balance/getmetalbalancehistory`,
       {
        params: { page, limit, search },
      }
    );

    if (!res?.data?.success) {
      yield put(setError(res.data.errormsg || "Something wrong!"));
      return;
    }

    console.log(res.data.data, "history");

    // ✅ Add `id` to each item using map
    yield put(
      setMetalHisory({
        data: res.data.data,
        total: res.data.total,
      })
    );
  } catch (err) {
    yield put(setError(err.response?.data?.message || "Failed to get metal"));
  }
}

function* handleUpdateRedeemTimeOut(action) {
  try {
    const res = yield axios.post(
      ` ${process.env.REACT_APP_API_BASE_URL}/api/v1/bullion/updateRedeemTimeOut`,
      action.payload,
    );
    if (!res?.data?.success) {
      toast.error(res.data.message);
      yield put(setError(res.data.message || "Something wrong!"));
      return;
    }
    toast.success(res.data.message);
    yield put(getMetals());
    yield put(setMessage(res.data.message));
  } catch (err) {
    yield put(setError(err.response?.data?.message || "Failed to add time"));
  }
}

export function* manageMetalsSaga() {
  yield takeLatest(addMetal.type, handleMetalName);
  yield takeLatest(addKarat.type, handleAddKarat);
  yield takeLatest(addPurity.type, handleAddPurity);
  yield takeLatest(changeStatus.type, handleChangeStatus);
  yield takeLatest(updateSellOutTime.type, handleUpdateSellOutTime);
  yield takeLatest(addQuantity.type, handleAddQuantity);
  yield takeLatest(removeQuantity.type, handleRemoveQuantity);
  yield takeLatest(downloadMetalReport.type, handleDownloadMetalReport);
  yield takeLatest(fetchKarat.type, handleFetchKarat);
  yield takeLatest(getMetals.type, handleGetMetals);
  yield takeLatest(addBullion.type, handleaddBullion);
  yield takeLatest(getPuritiesByKaratId.type, getPurities);
  yield takeLatest(getMetalHistory.type, handleGetMetalHistory);
  yield takeLatest(updateRedeemTimeOut.type, handleUpdateRedeemTimeOut);
}
